import React, { useEffect, useState } from 'react';
import { Skeleton, Empty } from 'antd';
import api from '../../../services/api';
import TeamMatchesPanel from '../../../components/community/TeamMatchesPanel';

// Wrapper de tabela de jogos dentro do admin.futezap.com.br.
export default function AdminCommunityMatches() {
  const [teamId, setTeamId] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get('/community/teams/profile')
      .then(r => setTeamId(r.data?.id || null))
      .catch(() => setTeamId(null))
      .finally(() => setLoading(false));
  }, []);
  if (loading) return <div style={{ padding: 40 }}><Skeleton active /></div>;
  if (!teamId) return <Empty description="Perfil de time não encontrado" style={{ padding: 60 }} />;
  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 16 }}>
      <TeamMatchesPanel teamId={teamId} />
    </div>
  );
}
